import { useAuth } from '../contexts/AuthContext'
import { API_BASE_URL } from '../config'

export interface Payment {
  id: string;
  clientId: string;
  tenantId: string;
  payerId: string;
  amount: number; // cents
  description?: string;
  transactionDate: string;
  pinchPaymentId?: string;
  status?: string;
  createdAt: string;
  [key: string]: unknown;
}

export interface CreatePaymentPayload {
  amount: number; // cents
  description?: string;
  transactionDate?: string;
}

export const usePaymentService = () => {
  const { token, authFetch } = useAuth()

  const listPayments = async (clientId: string): Promise<Payment[]> => {
    if (!token) {
      return []
    }

    const response = await authFetch(`${API_BASE_URL}/clients/${clientId}/payments`)

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data?.error || `Failed to list payments: ${response.status}`)
    }

    return data.payments || []
  }

  const createPayment = async (clientId: string, payload: CreatePaymentPayload): Promise<Payment> => {
    if (!token) {
      throw new Error('Not authenticated')
    }

    const response = await authFetch(`${API_BASE_URL}/clients/${clientId}/payments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data?.error || `Failed to create payment: ${response.status}`)
    }

    return data.payment
  }

  return { listPayments, createPayment }
}
